<template>
  <v-layout row justify-center>
    <v-dialog persistent max-width="500px"></v-dialog>
  </v-layout>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
} from 'vuex'
import auth from '@/config/auth'

export default {
  name: 'notification',
  data: () => ({
  }),
  computed: {
    ...mapState('app', ['notificationDialog']),
    ...mapGetters('auth', [
    ]),
  },
  methods: {
    ...mapActions('auth', [
    ]),
    getNotifications () {

    },
  },
  created () {
    this.getNotifications()
  },
}

</script>
